import React from 'react';
import { TrustpilotWidgetProps } from './trustpilot-widget.props';

export const TrustpilotWidgetOrganism = (props: TrustpilotWidgetProps) => {
  const ref = React.useRef(null);
  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (window.Trustpilot) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);
  return (
    <div
      data-cy="trustpilot-widget"
      ref={ref}
      className="trustpilot-widget mt-5"
      data-locale="en-US"
      data-template-id={props.templateId}
      data-businessunit-id="596e31be0000ff0005a6ee16"
      data-style-height={props.styleHeight}
      data-style-width="100%"
      data-theme={props.theme}
    >
      <a
        href="https://www.trustpilot.com/review/hiwaldo.com"
        target="_blank"
        rel="noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};
